import { computeAdjacentPosition, computeRowAwareAppendPosition, type NodeRect, type Size } from './nodeLayout';

export type ComputePositionBesideSourceParams = {
  allNodes: NodeRect[];
  gap: number;
  maxRowWidth: number;
  newNodeSize: Size;
  sourceId: string;
};

export type PositionBesideSource = {
  placedBesideSource: boolean;
  position: { x: number; y: number };
};

/**
 * Places a result next to its source (right → below → left → above) so before/after
 * stays readable. Falls back to the source's row-append when the source is boxed in
 * or missing from `allNodes`.
 */
export const computePositionBesideSource = ({
  allNodes,
  gap,
  maxRowWidth,
  newNodeSize,
  sourceId,
}: ComputePositionBesideSourceParams): PositionBesideSource => {
  const sourceRect = allNodes.find((rect) => rect.id === sourceId);

  if (sourceRect) {
    const adjacent = computeAdjacentPosition({
      allNodes,
      anchor: sourceRect,
      gap,
      newNodeSize,
    });

    if (adjacent) {
      return { placedBesideSource: true, position: adjacent };
    }
  }

  return {
    placedBesideSource: false,
    position: computeRowAwareAppendPosition({
      allNodes,
      gap,
      maxRowWidth,
      newNodeSize,
      targetRowNodeId: sourceId,
    }).position,
  };
};
